import { render, staticRenderFns } from "./FiltroPrefeituras.vue?vue&type=template&id=20835f6f"
import script from "./FiltroPrefeituras.vue?vue&type=script&lang=js"
export * from "./FiltroPrefeituras.vue?vue&type=script&lang=js"
import style0 from "./FiltroPrefeituras.vue?vue&type=style&index=0&id=20835f6f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports